import React from "react";
import classNames from "classnames";
import { Link } from 'react-router-dom'

export default function FeaturedItems(props) {
  return (
    <Link className="col-12 col-md-8 col-lg-4  full-card-div div-zoom" to={props.item.link}>
      <div className='img-hover-zoom mt-2'>
      <img
        src={props.item.img}
        alt="Item"
        className="img-fluid featured-photo card-img-top"
      />

      </div>
      <div className="card-body">
        <h5 className="card-title">{props.item.title}</h5>
        <blockquote className="blockquote">
          <p className="card-text text-justify">{props.item.quote}</p>
          <footer
            className={classNames(
              "blockquote-footer",
              props.item.autor === null ? "hidden" : ""
            )}
          >
            {props.item.autor}
          </footer>
        </blockquote>

        <Link to={props.item.link} className="card-link mx-auto">
          More info
        </Link>
      </div>
    </Link>
  );
}
